<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Thèse d’exercice">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold font-italic">
                Les facultés de pharmacie de Lille et d’Amiens souhaitent
                encourager les thèses d’exercice incluant un travail pratique
                coordonné conjointement par un pharmacien d’officine et un
                enseignant de la faculté
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Avez-vous déjà participé à un jury de thèse d’exercice au
                cours des 5 dernières années ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.participationJury"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="participationJury"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="participationJury"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.participationJury">
            <v-col cols="1" />
            <v-col cols="12" md="6">
              <v-select
                v-model="dossier.nbParticipationJury"
                :items="labelsParticipationJury"
                label="Si oui, nombre de participations à un jury sur les 5 dernières années ?"
                required
                :rules="textRules"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Souhaitez-vous proposer un travail au sein de votre
                officine pouvant donner lieu à une thèse d’exercice ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.travailThese"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="travailThese"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="travailThese"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.travailThese">
            <v-col cols="1" />
            <v-col cols="12" md="6">
              <v-text-field
                v-model="dossier.travailTheseThematique"
                label="Si oui, sur quelle(s) thématique(s) ?"
                hint="(ETP, mise en place d’une démarche qualité à l’officine, amélioration des pratiques, projet
d’équipe en soins premiers, développement d’entretiens pharmaceutiques…) ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Souhaitez-vous vous engager dans l’encadrement d’un
                étudiant sur un travail de thèse d’exercice ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.travailTheseEngagement"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="travailTheseEngagement"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="travailTheseEngagement"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie16",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    labelsParticipationJury: ["1", "2", "3", "4", "5", "plus de 5"],
    dateFormationEtp: null,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "La superficie doit être composée uniquement de chiffres"
    ]
  }),
  computed: {
    formatedDate() {
      return this.dateFormationEtp
        ? moment(this.dateFormationEtp).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.dateFormationEtp = this.dateFormationEtp;
        if (!this.dossier.travailThese)
          this.dossier.travailTheseThematique = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
